import MyFavorite from "./MyFavorite";
import RecentSearches from "./RecentSearches";
import ActiveJobs from "./ActiveJobs";
import DashboardCounts from "./DashboardCounts";
import FirmInNetwork from "./FirmInNetwork";
import ClientRecommendation from "./ClientRecommendation";
import ScreenHeader from "../Headers/ScreenHeader";
import { useAuthContext } from "../../context/AuthContext";

const DashboardComponent = () => {
  const { userDetails } = useAuthContext();
  const user_primary_role = JSON.parse(userDetails).user_primary_role;

  return (
    <div className="d-block">
      <ScreenHeader title={"Dashboard"} subText={"Welcome back"} />
      <div className="d-block">
        {user_primary_role !== "3" && (
          <div className="d-block mt-4">
            <DashboardCounts />
          </div>
        )}
        <div className="d-block mt-4">
          <div class="row gx-3">
            <div class="col-12 col-md-6 mb-3 mb-md-0">
              <MyFavorite />
            </div>
            <div class="col-12 col-md-6 mb-3 mb-md-0">
              <RecentSearches />
            </div>
          </div>
        </div>
        <ClientRecommendation />
        <div class="d-block mt-lg-4">
          <div class="row gx-3">
            <div class="col-12 col-md-7 mb-3 mb-md-0">
              <ActiveJobs />
            </div>
            <div class="col-12 col-md-5 mb-3 mb-md-0">
              <FirmInNetwork />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardComponent;
